module.exports = __webpack_public_path__ + "img/project_icon_two.cfd7c75a.png";